<template>
  <v-tooltip class="noneOpacity" content-class="employee" bottom color="#ffffff">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <router-link
          :to="{
            name: 'PersonalAreaEmployee',
            params: { userId: employee.user.id },
          }"
          class="chip f14"
          :class="{ status: status }"
        >
          <EmployeesPhoto
            :size="15"
            :img="employee.user.photo"
            :textFirst="employee.user.last_name"
            :textSecond="employee.user.first_name"
          />
          <span>{{ employee.user.first_name + ' ' + employee.user.last_name }}</span>
        </router-link>
      </div>
    </template>
    <div class="employee__tooltip">
      <EmployeesPhoto
        :size="100"
        :img="employee.user.photo"
        :textFirst="employee.user.first_name"
        :textSecond="employee.user.last_name"
      />
      <div class="employee__tooltip_box">
        <div class="status f13">
          {{ localStorage.translations.pages.common.text['net-dannyh'] }}
        </div>
        <div class="name f14">
          {{ employee.user.first_name + ' ' + employee.user.last_name }}
        </div>
        <div v-if="employee.user.email" class="f14">
          {{ employee.user.email }}
        </div>
        <div class="role f12">
          {{
            employee.user.work_role
              ? employee.user.work_role.name
              : localStorage.translations.pages.personnel_department.employees_card[
                  'dolzhnost-ne-naznachena'
                ]
          }}
        </div>
      </div>
    </div>
  </v-tooltip>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import EmployeesPhoto from 'components/employees/EmployeesPhoto'

export default {
  name: 'EmployeesTooltip',
  components: {
    EmployeesPhoto,
  },
  props: ['employee', 'status'],
  data: () => ({}),
  created() {},
  updated() {},
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters('workTypeCategory', ['workTypeCategoryGridAll']),
    ...mapGetters('workClientProjectsWorkType', ['workClientProjectsWorkTypeAll_project']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.chip {
  border: 1px solid #bedbeb;
  width: max-content;
  padding: 8px;
  border-radius: 4px;
  color: #2c2c2c;
  height: max-content;
  cursor: pointer;
  overflow: hidden;
  display: grid;
  grid-template-columns: max-content auto;
  gap: 10px;
  white-space: nowrap;
  max-width: max-content;
  &.status {
    border: none;
    background-color: #277faf;
    color: #ffffff;
  }
  span {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}
</style>

<style lang="scss">
.v-tooltip__content {
  &.employee {
    .employee__tooltip {
      display: grid;
      grid-template-columns: max-content auto;
      column-gap: 10px;
      &_box {
        display: grid;
        row-gap: 10px;
        .status {
          background-color: #959595;
        }
        .name {
          color: #2c2c2c;
        }
        .role {
          color: #6ab1d8;
        }
      }
    }
  }
}
</style>
